import { GET_ALL_DATA, SET_LOADING, CLEAR_CONTRACT_LOST_DATA } from './types'

const initialState = {
  data: {
    data: [],
    query: {
      totalRecords: 0,
      limit: 5,
      first: 0,
    },
  },
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case CLEAR_CONTRACT_LOST_DATA:
      return {
        ...state,
        data: {
          data: [],
          query: {
            totalRecords: 0,
            limit: 5,
            first: 0,
          },
        },
      }
    case GET_ALL_DATA:
      return {
        ...state,
        data: {
          data: action.payload.data,
          query: action.payload.query,
        },
        isLoading: false,
      }
    default:
      return state
  }
}
